import i18n from "@/i18n";

// The server reads a stored early-access time without a zone as UTC, so the client does too.
const toDate = (v) => {
  if (!v) return null;
  const s = String(v);
  const d = new Date(/([zZ]|[+-]\d\d:?\d\d)$/.test(s) ? s : `${s}Z`);
  return Number.isNaN(d.getTime()) ? null : d;
};

// The early-access end date while it is still ahead, else null.
export const earlyUntil = (v) => {
  const d = toDate(v);
  return d && d > new Date() ? d : null;
};

// Long date in the viewer's language, date only, on the server's (UTC) calendar day.
export const fmtEarlyDate = (d) =>
  new Intl.DateTimeFormat(i18n.language || "en", { dateStyle: "long", timeZone: "UTC" }).format(d);
